import { Outlet, createFileRoute } from '@tanstack/react-router';

import { VStack } from '@/components/Layout';

import { NetworkProfileHeader } from './-components/NetworkProfileHeader';

export const Route = createFileRoute('/_staff/networks/$id/_layout')({
  component: Layout,
});

function Layout() {
  return (
    <VStack>
      <NetworkProfileHeader />
      <Outlet />
    </VStack>
  );
}
